"use client";

import { ProjectsPageContainer } from "@/presentation/projects/ProjectsPageContainer";

export default function ProjectsPage() {
  return <ProjectsPageContainer />;
}
